import { LabeledContainer, Checkbox } from '@schibsted-svp/react-ui';
import type { UseFormRegister } from 'react-hook-form';
import QuestionMark from 'components/ui/QuestionMark';
import type { FormValues } from '../types';
import css from './LivingThumbnail.module.scss';

type LivingThumbnailProps = {
    wasLive: boolean;
    register: UseFormRegister<FormValues>;
};

export function LivingThumbnail({ wasLive, register }: LivingThumbnailProps) {
    return (
        <LabeledContainer
            label={
                <>
                    Living Thumbnail{' '}
                    <QuestionMark content="Replaces the main image of the video asset with the most recent image captured from the live stream, updated every 10 minutes." />
                </>
            }
        >
            <Checkbox
                {...register('additional.metadata.livingThumbnail')}
                label="Living thumbnail"
                containerClassName={css.checkbox}
                disabled={wasLive}
            />
        </LabeledContainer>
    );
}
